<template>
  <div class="app-root">
    <div class="app-toolbar">
      <button @click="initAll">开启直播</button>
    </div>
    <div class="app-video-wrapper">
      <videoSurveillance
        style="height: 90vh"
        :defaultQuantity="1"
        :operationList="[{ type: 5, name: '断 开' }]"
        ref="videoSurveillance"
      > </videoSurveillance>
    </div>
    <div class="app-footer">设备在线</div>
  </div>
</template>
<script lang="js">
  export default {
     data() {
      return {
        userInfo: null,
        deviceId:'',
        deviceInfo:"",
        url:"https://www.hy-ser-v3-tmp.huayu-et.com",
        token: '', // 平台token
      }
    },
    created(){
      const token = new URLSearchParams(window.location.search).get('token');
      const deviceId = new URLSearchParams(window.location.search).get('deviceId');
      console.log('token', token)
      console.log('deviceId', deviceId)
      if (token){
        this.token = token;
      }else {
        this.$message.error('缺少token参数')
      }
      if (deviceId){
        this.deviceId = deviceId;
      }else {
        this.$message.error('缺少deviceId参数')
      }
      // this.initAll();
    },
    mounted() {

    },
    methods:{
      // 重新连接
      reconnect()
      {
          this.loginByToken();
      },
      // token登录
      loginByToken() {
       return this.$sdk.loginByToken({
          requestHeader:this.url, // 请求头地址：https://www.XXXX.com/
          token: this.token,
          event:{
            // mqtt 断开通知

          }
      }, this.$sdk, this.$business).then((res) => {
          console.log('成功返回用户信息', res)
          this.userInfo = res.data
          // this.bulkSubscriptionDevice()
        }).catch((res) => {
          console.log('失败返回错误内容', res)
          throw res
        })
    },
    deviceDetailFn() {
      if (this.deviceId) {
        return this.$refs.videoSurveillance
          .deviceDetailFn( this.deviceId)
          .then((res) => {
            if (res.code === 200) {
              this.device = res.data
              this.active = 2
            }
            this.$message.success('操作成功')
            console.log('成功', res)
          })
          .catch((res) => {
            console.log('失败', res)
            throw res
          })
      } else {
        this.$message.error('数据错误')
      }
    },
    addNewRoomFn() {
      console.warn('this.device', this.device)
      return this.$refs.videoSurveillance.addNewRoomFn(this.device)
    },
    // 依次执行：登录 → 获取设备详情 → 开启直播
    async initAll() {
      if(this.token === '' || this.deviceId === ''){
        this.$message.error('缺少必要参数，无法开启直播')
        return
      }
      try {
        await this.loginByToken()
      } catch (e) {
        console.log('登录失败', e)
        this.$message.error('登录失败')
        return
      }
      try {
        await this.deviceDetailFn()
      } catch (e) {
        console.log('获取设备详情失败', e)
        this.$message.error('获取设备详情失败')
        return
      }
      try {
        await this.addNewRoomFn()
        console.log('一键初始化完成')
      } catch (e) {
        console.log('开启直播失败', e)
        this.$message.error('开启直播失败')
      }
    }

  }}

</script>
<style scoped>
/* ===== 全局容器 ===== */
div {
  box-sizing: border-box;
}

/* ===== 页面根容器 ===== */
.app-root {
  display: flex;
  flex-direction: column;
  height: 100vh;
  margin: 0;
  padding: 0;
  background: linear-gradient(135deg, #0f1923 0%, #1a2a3a 50%, #0d1b2a 100%);
  font-family: 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', sans-serif;
  overflow: hidden;
}

/* ===== 顶部工具栏 ===== */
.app-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  flex-shrink: 0;
}

.app-toolbar::before {
  content: '📹 视频监控';
  font-size: 18px;
  font-weight: 600;
  color: #e0e6ed;
  letter-spacing: 1px;
}

/* ===== 开启直播按钮 ===== */
.app-toolbar button {
  position: relative;
  padding: 10px 28px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  background: linear-gradient(135deg, #00b894 0%, #00a381 100%);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  letter-spacing: 0.5px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 15px rgba(0, 184, 148, 0.3);
  outline: none;
  user-select: none;
}

.app-toolbar button::before {
  content: '▶ ';
  font-size: 10px;
}

.app-toolbar button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(0, 184, 148, 0.45);
  background: linear-gradient(135deg, #00d9a7 0%, #00b894 100%);
}

.app-toolbar button:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(0, 184, 148, 0.3);
  transition: all 0.1s ease;
}

/* ===== 视频区域容器 ===== */
.app-video-wrapper {
  flex: 1;
  margin: 16px 20px 20px;
  border-radius: 12px;
  overflow: hidden;
  background: #000;
  box-shadow:
    0 0 0 1px rgba(255, 255, 255, 0.06),
    0 8px 32px rgba(0, 0, 0, 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.03);
  transition: box-shadow 0.3s ease;
}

.app-video-wrapper:hover {
  box-shadow:
    0 0 0 1px rgba(255, 255, 255, 0.1),
    0 12px 40px rgba(0, 0, 0, 0.5),
    inset 0 1px 0 rgba(255, 255, 255, 0.05);
}

.app-video-wrapper > * {
  width: 100%;
  height: 100%;
}

/* ===== 右下角状态指示器 ===== */
.app-footer {
  position: fixed;
  bottom: 28px;
  right: 32px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  pointer-events: none;
  z-index: 10;
}

.app-footer::before {
  content: '';
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #00b894;
  box-shadow: 0 0 8px rgba(0, 184, 148, 0.6);
  animation: pulse-dot 2s ease-in-out infinite;
}

@keyframes pulse-dot {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.5; transform: scale(1.3); }
}

/* ===== 响应式适配 ===== */
@media (max-width: 768px) {
  .app-toolbar {
    padding: 12px 16px;
  }

  .app-toolbar::before {
    font-size: 15px;
  }

  .app-toolbar button {
    padding: 8px 20px;
    font-size: 13px;
  }

  .app-video-wrapper {
    margin: 10px 12px 12px;
    border-radius: 8px;
  }
}
</style>